export const STAFF = 'staff';
export const MEMBER = 'member';
export const AUTHOR = 'author';
export const COMPANY = 'company';
export const CHARITY = 'charity';
export const FUNDRAISER = 'fundraiser';
export const MTS_ACCOUNT = 'missing-type';

export const BLOGGER = 'blogger';
export const VLOGGER = 'vlogger';
export const PODCAST = 'podcaster';
export const GUESTPOST = 'guest-post';
export const ADVISOR = 'advisor';
export const ONLINESTORE = 'online-store';
export const PAIDPREMIUMGROUP = 'paid-premium-group';
export const ONLINECOURSE = 'online-course';
export const INFLUENCERMARKETPLACE = 'influencer-marketing';
export const SERVICES = 'services';
export const JOB = 'job';
export const ECOMMERCE = 'ecommerce';
export const INVESTMENT = 'investment';
export const POLITICIAN = 'politician';
export const HOSTEVENT = 'host-event';
export const RESTAURANT = 'restaurant';
export const VACATIONSRENTALS = 'vacations-rentals';
export const HAIRSALON = 'hair-salon';
export const PROVIDER = 'provider';
export const CUSTOMER_SERVICE = 'customer-service';
export const CUSTOMER_SERVICE_ADMIN = 'customer-service-admin';
